module.exports = __webpack_public_path__ + "static/media/success.041ca3fd.svg";